module.exports = __webpack_public_path__ + "img/me-header-background-zh.29f13572.png";